export const environment = {
  name: 'development',
  apiBaseUrl: 'http://localhost:1234',
};
